import React, { useId } from 'react';

import Image from 'next/image';

import { Mousewheel, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import 'swiper/css/pagination';

import styles from './Authors.module.scss';

function Authors({ items }) {
  const id = useId();

  return (
    <div className={styles.wrapper}>
      <Swiper
        id={id}
        className={styles.slider}
        modules={[Pagination, Mousewheel]}
        slidesPerView={1}
        pagination={{
          enabled: items.lenght > 1,
          el: `.${styles.paginationWrapper}`,
          clickable: true,
        }}
        breakpoints={{
          480: {
            slidesPerView: 2,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
          },
          767: {
            slidesPerView: 3,
          },
        }}
        mousewheel={{
          enabled: true,
          forceToAxis: true,
        }}
      >
        {items.map((author) => {
          const authorHighlights = author?.description?.split('\n');

          return (
            <SwiperSlide key={`course-author-${author.id}`}>
              <div className={styles.author}>
                <div className={styles.authorInfo}>
                  <div className={styles.thumbnailWrapper}>
                    <Image src={author?.profilePic} height={64} width={64} alt={author?.name} />
                  </div>

                  <div className={styles.authorNameWrapper}>
                    <span className={styles.authorName}>{author?.name}</span>
                    <span className={styles.authorDesignation}>{author?.designation}</span>
                  </div>
                </div>

                <ul className={styles.authorHighlights}>
                  {authorHighlights?.map((description, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={`author-${author?.id}-highlight-${index}`}>{description}</li>
                  ))}
                </ul>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <div className={styles.paginationWrapper} />
    </div>
  );
}

export default Authors;
